/**
 * Store for Sandboxed functions
 * @module
 */

var actionTypes = require('../constants/action_types');

module.exports = {
  initialize: function() {
    this.__state = {
      initialized: false,
      natives: {},
    };
    this.on(actionTypes.SANDBOXED_FUNCTIONS_ADDED, this.__addFunctions);
  },

  /**
   * Adds Sandboxed functions into the store
   * @param {Object} payload
   * @param {Object} payload.sandboxedFunctions
   * @private
   */
  __addFunctions: function(payload:any) {
    if (payload.sandboxedFunctions) {
      this.__state.natives = payload.sandboxedFunctions;
      this.__state.initialized = true;
      this.emitChange();
    } else {
      throw new Error('No sandboxedFunctions found in payload');
    }
  },

  /**
   * Returns all the sandboxed functions and definition
   * @returns {Object}
   */
  getAll: function(): any {
    return this.__state.natives;
  },

  /**
   * Returns the definition of function of the given name
   * @param {string} name
   * @returns {Object|null}
   */
  get: function(name:string): any|null {
    if (!name) {
      throw new Error('Missing name parameter');
    }
    return this.__state.natives[name] || null;
  },

  /**
   * Returns if the state is initialized
   * @returns {boolean}
   */
  isInitialized: function(): boolean {
    return this.__state.initialized;
  },
};
